// extracted by mini-css-extract-plugin
export var active = "LocationTab-module--active--aff10";
export var dropdownArrow__icon = "LocationTab-module--dropdownArrow__icon--ee662";
export var icon = "LocationTab-module--icon--1ed97";
export var locationHeaderIcon = "LocationTab-module--locationHeaderIcon--4801c";
export var locationTab = "LocationTab-module--locationTab--46e02";
export var locationTab__trim = "LocationTab-module--locationTab__trim--b98d5";
export var mainOffice__icon = "LocationTab-module--mainOffice__icon--a6dba";
export var mapPin__icon = "LocationTab-module--mapPin__icon--21448";
export var phone__icon = "LocationTab-module--phone__icon--365c6";
export var phone__link = "LocationTab-module--phone__link--029c1";